import React, { Component } from 'react';
import { connect } from 'react-redux';
import { busyState, popupState, popupDispatcher, combineStates, identityState } from '../store';
import { BusyContainer, PopupMessage, PopupType, SvgImage } from '.';
import { closeIcon } from '../../style/images';
import { PropTypes } from 'prop-types';
import {translate} from '../services';
import { ErrorComponent } from './ErrorComponent';
import classNames from 'classnames';

const CloseIcon = ( { id, onClick } ) => {
  const close = () => onClick( id );
  return <SvgImage source={ closeIcon } className="close-icon" onClick={ close } />;
};

const Overlay = ( { children, id, onClick, className } ) => {
  const hide = e => onClick( e, id );
  return <div className={classNames("overlay",{"edit-configure-page-overlay":className==="edit-configure-page-overlay"?true:false})} onClick={ hide }>
    { children }
  </div>;
};

const PopupContent = ( { Component, id, onHide } ) => {
  const closePopup = () => onHide( id );
  return <Component className="invisible" hidePopup={ closePopup }/>; 
};

export class PopupComponent extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      isLoading: false,
      isLoaded: false,
      hasError: false
    };
  }

  static getDerivedStateFromError( error ) {
    return {
      hasError: true,
      error
    };
  }

  componentDidUpdate() {
    let popupContent = document.getElementById( 'popupContent' );
    if ( popupContent && !this.state.isLoading && !this.state.isLoaded ) {
      this.setState( { isLoading: true } );
      popupContent.addEventListener( 'load', () => {
        this.setState( { isLoading: false, isLoaded: true } );
      } );
    }
  }

  resetErrorState = e => {
    if (e.defaultPrevented) {
      return;
    }
    this.setState( { hasError: false, error: null } );
  }

  hide = ( e, id ) => {
    if ( e && e.target && e.target.className && typeof e.target.className === 'string' && e.target.className.includes( 'overlay' ) && !this.props.popup.keepOpen ) {
      if(this.props.popup?.isFeasibilityPopup)
      this.closePopup( id );
    }
  }

  redirect = () => {
    const apttusUrl = this.props.user.properties["ApttusURL"];
    window.location.href = apttusUrl;
  }
  
  closePopup = id => {
    this.setState( { isLoading: false, isLoaded: false } );
    if(this.props.popup.find(p => p.id === id)?.showConfirmation) {
      this.showConfirmationMessage( id );
    } else this.props.hidePopup( id );
  }

  showConfirmationMessage = (id) => {
    this.props.setPopup( 
      {
        title: `Warning`,
        component: <PopupMessage
          text={ translate('WARNING_CONFIGURATION_NOT_SAVED') } 
          actionText={ translate( 'Yes' ) } 
          cancelText={ translate( 'No' ) }
          onClick={ () => this.props.hidePopup( id )}
          popupType={ PopupType.Warning }
        />,
        showHeader: true,
        keepOpen: true 
      } 
    );
  }
  
  render() {
    const { busyState, popup, user } = this.props;
    const { hasError, error } = this.state;
    const isApttusReconfig = ( user.authenticationType === "Apttus" ) && ( user.properties["Action"] === "Reconfig" );
    
    if( !popup || !popup.length ) {
      return null;
    }

    if ( hasError ) {
      return <Overlay onClick={ this.resetErrorState }>
        <div className="popup">
          <ErrorComponent error={ error } />
        </div>
      </Overlay>;
    }
    
    let isBusy = this.state.isLoading || busyState && Object.keys( busyState ).any( action => busyState[action] );
    
    let popups = popup.map( ( popup, key ) => {
      let Header = !popup.header ? null :
        <div className="popup-header">
          { translate( popup.title ) }
          {/* <BusyContainer isBusy={ isBusy } /> */}
          <CloseIcon id={ popup.id } onClick={ isApttusReconfig ? this.redirect : this.closePopup } />
        </div>;

      let Component = popup.content;
      
      return <Overlay className={popup?.className} key={ key } id={ popup.id } onClick={ this.hide }>
        <div className="popup">
          { popup.title?.includes('Wild Articles') && Header && Header.apply ? <Header /> : popup.title?.includes('Wild Articles') ? Header : null }
          { Component.apply 
            ? <PopupContent id={ popup.id } Component={ Component } onHide={ this.closePopup }/> 
            : React.cloneElement( Component, { hidePopup: () => this.closePopup( popup.id ) } ) } 
        </div>
      </Overlay>;
    } );
    
    return popups;
  }
}

PopupComponent.propTypes = {
  busyState: PropTypes.shape( {} ),
  hidePopup: PropTypes.func.isRequired,
  popup: PropTypes.arrayOf( PropTypes.shape( {
    content: PropTypes.node,
    header: PropTypes.bool,
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  } ) ),
};

export const Popup = connect( combineStates( busyState, popupState, identityState ), popupDispatcher )( PopupComponent );